<template>
  <div>
    <v-card class="ma-3" outlined>
      <v-card-text class="pa-1">
        <v-row no-gutters>
          <v-text-field v-model="c_query" class="ma-1" outlined dense hide-details clearable label="Caută" background-color="white" prepend-inner-icon="mdi-magnify"/>
          <v-divider vertical class="ma-1"/>
          <div class="ma-1">
            <v-btn depressed color="create white--text" block height="40" @click="$emit('create')">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </div>
        </v-row>
      </v-card-text>
    </v-card>

  </div>

</template>


<script>

  export default {

    props: {
      query: null
    },

    data: () => ({
      name: null,
      supplier: null,
      suppliers: null,
      loading: false,
      dialog: false,
    }),

    computed: {
      c_query: {
        get() {
          return this.query;
        },
        set(val) {
          this.$emit("update:query", val);
        }
      }
    },

    async created() {
      try {

      } catch (e) {
        await this.$store.dispatch('alert/error', e);
      }
    },

    methods: {
      save: async function () {

      }
    }

  }
</script>